import Icon from 'veui/components/Icon'
import { IconEllipsisVertical } from 'dls-icons-vue'

Icon.register('ellipsis-vertical', IconEllipsisVertical)
